module.exports = __webpack_public_path__ + "static/img/weixin.0d8d0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin.png
// module id = q0uv
// module chunks = 15